import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    parkings: {
        id: 'parkings',
        defaultMessage: 'Parkings',
    },
    lastOpened: {
        id: 'last-opened',
        defaultMessage: 'Last opened',
    },
    viewAllParkings: {
        id: 'view-all-parkings',
        defaultMessage: 'View all parkings',
    },
    currentParkingChangeSuccess: {
        id: 'current-parking-change-success',
        defaultMessage: 'Current parking changed',
    },
    currentParkingChangeSuccessDetails: {
        id: 'current-parking-change-success-details',
        defaultMessage: 'You are now viewing parking information about <b>{parkingName}</b>',
    },
    notAMember: {
        id: 'not-a-member',
        defaultMessage: 'Not a member',
    },
    notAMemberDescription: {
        id: 'not-a-member-description',
        defaultMessage:
            'It appears that you are not a member of any current SmartPark parking. Please contact your parking administrator for more information.',
    },
    logout: {
        id: 'logout',
        defaultMessage: 'Logout',
    },
})